import { select } from 'd3-selection';

const defaults = {
  target: '#calendar',
  data: [],
  margin: { top: 0, right: 0, bottom: 0, left: 0 }
};

export default class Calendar {
  constructor(config) {
    this.set(config);
  }

  set(config) {
    Object.assign(this, defaults, config);
  }

  draw() {
    const { data, target, margin } = this;
    const container = select(`${target}`).html('');
    const bounds = container.node().getBoundingClientRect();
    const width = bounds.width - margin.left - margin.right;

    const format = width > 400 ? 5 / 1 : 5 / 4;
    const squareMargin = .2;

    const createGrid = () => {
      let gridWidth = 500;
      let nSquares = 144;
      let squareMargin = .1;
      let format = 16 / 9;

      function grid() {
        let squareWidth =  gridWidth / Math.sqrt(nSquares * format);
        let nSquaresPerRow = Math.floor(gridWidth / squareWidth);
        squareMargin *= squareWidth;
        squareWidth = gridWidth / nSquaresPerRow - squareMargin;
        let gridHeight = Math.ceil(nSquares / nSquaresPerRow) * (squareWidth + squareMargin);

        const squares = [];
        for (let i = 0; i < nSquares; i++) {
          let square = {};
          square.x = .5 * squareMargin + (squareWidth + squareMargin) * (i % nSquaresPerRow);
          square.y = .5 * squareMargin + (squareMargin + squareWidth) * Math.floor(i / nSquaresPerRow);
          squares.push(square);
        }
        return {squares: squares, squareWidth: squareWidth, height: gridHeight};
      }

      grid.gridWidth = (value) => {
        gridWidth = value == undefined ? gridWidth : value;
        return grid;
      };

      grid.nSquares = (value) => {
        nSquares = value == undefined ? nSquares : value;
        return grid;
      };

      grid.squareMargin = (value) => {
        squareMargin = value == undefined ? squareMargin : value;
        return grid;
      };

      grid.format = (value) => {
        format = value == undefined ? format : value;
        return grid;
      };

      return(grid);
    };

    const colorScale = (value) => {
      switch (true) {
        case value == 0:
          return('#f0f0f0'); // grey
        case value <= 12:
          return('#ffeda0'); // yellow
        case value <= 96:
          return('#feb24c'); // orange
        default:
          return('#f03b20'); // red
      }
    };

    const grid = createGrid()
      .gridWidth(width)
      .nSquares(data.calendar.length)
      .squareMargin(squareMargin)
      .format(format)();

    // grid.squares.map((square, i) => { square.color = colorScale(data.calendar[i]); })

    const svg = container
      .append('svg')
      .attr('width', bounds.width)
      .attr('height', grid.height + margin.top + margin.bottom);

    const g = svg
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`);

    const squares = g.selectAll('.square').data(grid.squares);

    squares
      .enter()
      .append('rect')
      .attr('class', 'square')
      .attr('x', square => square.x)
      .attr('y', square => square.y)
      .attr('width', grid.squareWidth)
      .attr('height', grid.squareWidth)
      // .attr('stroke-width', .1)
      // .attr('stroke', '#898989')
      .attr('fill', (square, i) => colorScale(data.calendar[i]));

    squares.exit().remove();
  }

  update() {
    this.draw();
  }
}
